module.exports = __webpack_public_path__ + "static-portal/img/icon-01.967e985.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/HomeManage/module/icons/icon-01.png
// module id = 6OpB
// module chunks = 4